import React, { useEffect, useState } from "react";
import Navbar from "../components/navbar";
import { Receipt } from "../../../domain/models/receipt-model";
import { useNavigate } from "react-router-dom";

export const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.innerWidth <= 768 && navigate("/mobile/tasks");
  }, []);

  return (
    <>
      <Navbar title="Entradas" />
    </>
  );
};
